<template>
  <div id="main-wrapper">
    <NavbarDark />
    <div class="page-title">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <h2 class="ipt-title">Contact Us</h2>
            <span class="ipn-subtitle">99 Property Mangement</span>
          </div>
        </div>
      </div>
    </div>

    <section>
      <div class="container">
        <div class="row">
          <div class="col-lg-8 col-md-7">
            <div class="contact-form">
              <form @submit.prevent="sendMessage">
                <div class="row">
                  <div class="col-lg-6 col-md-12">
                    <div class="form-group">
                      <label>Name</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Your Name"
                        v-model="formData.name"
                        :class="{ 'is-invalid': errors.name }"
                      />
                      <div v-if="errors.name" class="invalid-feedback">
                        {{ errors.name }}
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-12">
                    <div class="form-group">
                      <label>Email</label>
                      <input
                        type="email"
                        class="form-control"
                        placeholder="Your Email"
                        v-model="formData.email"
                        :class="{ 'is-invalid': errors.email }"
                      />
                      <div v-if="errors.email" class="invalid-feedback">
                        {{ errors.email }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Add the phone number field here -->
                <div class="form-group">
                  <label>Phone</label>
                  <input
                    type="tel"
                    class="form-control"
                    placeholder="Your Phone"
                    v-model="formData.phone"
                    @input="formatPhoneNumber" 
                    :class="{ 'is-invalid': errors.phone }"
                    maxlength="15" 
                  />
                  <div v-if="errors.phone" class="invalid-feedback">
                    {{ errors.phone }}
                  </div>
                </div>

                <div class="form-group">
                  <label>Subject</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Subject"
                    v-model="formData.subject"
                    :class="{ 'is-invalid': errors.subject }"
                  />
                  <div v-if="errors.subject" class="invalid-feedback">
                    {{ errors.subject }}
                  </div>
                </div>

                <div class="form-group">
                  <label>Message</label>
                  <textarea
                    class="form-control"
                    placeholder="Type Here..."
                    v-model="formData.message"
                    :class="{ 'is-invalid': errors.message }"
                  ></textarea>
                  <div v-if="errors.message" class="invalid-feedback">
                    {{ errors.message }}
                  </div>
                </div>
                <div class="form-group">
                  <button
                    class="btn btn-primary"
                    type="submit"
                    :disabled="isSending"
                  >
                  <span v-if="isSending" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                   {{ isSending ? 'Sending...' : 'Send Message' }}
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div class="col-lg-4 col-md-5">
            <div class="contact-info">
              <h2>Get In Touch</h2>
              <p>
                contact us for any queries or assistance. We are here to help
                you.
              </p>

              <div class="cn-info-detail mt-4">
                <div class="cn-info-icon">
                  <i class="fa-solid fa-house"></i>
                </div>
                <div class="cn-info-content">
                  <h4 class="cn-info-title">Reach Us</h4>
                  150 Edmonton Ave #4B <br />Moncton, NB , E1C 3B9.<br />Canada.
                </div>
              </div>

              <div class="cn-info-detail">
                <div class="cn-info-icon">
                  <i class="fa-solid fa-envelope-circle-check"></i>
                </div>
                <div class="cn-info-content">
                  <h4 class="cn-info-title">Drop A Mail</h4>
                  rent@99properties.ca
                </div>
              </div>

              <div class="cn-info-detail">
                <div class="cn-info-icon">
                  <i class="fa-solid fa-phone-volume"></i>
                </div>
                <div class="cn-info-content">
                  <h4 class="cn-info-title">Call Us</h4>
                  (+1) 506 889 7999
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center px-3 pb-1">
              <div class="teamgrid-social">
                <ul>
                  <li>
                    <a
                      href="https://www.facebook.com/rent99pm/"
                      class="f-cl"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i class="fa-brands fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/@realtorravithota"
                      class="y-cl"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i class="fa-brands fa-youtube"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/realtorravi/"
                      class="i-cl"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i class="fa-brands fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://wa.me/+15062333999"
                      class="l-cl"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i class="fa-brands fa-whatsapp"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div v-if="loading" class="spinner-overlay">
        <div class="spinner-container">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div> -->
    </section>

    <!-- <FooterTop :bg="'theme-bg'" /> -->
    <FooterDark />
    <ScrollToTop />
  </div>
</template>

<script setup>
import FooterDark from "@/components/footer/footer-dark.vue";
// import FooterTop from "@/components/footer/footer-top.vue";
import NavbarDark from "@/components/navbar/navbar-dark.vue";
import ScrollToTop from "@/components/scroll-to-top.vue";
import { ref } from "vue";
import { useRouter } from "vue-router";
import Swal from 'sweetalert2'; 
import 'sweetalert2/dist/sweetalert2.min.css'; // 3. Import the CSS for styling

const formData = ref({
  name: "",
  email: "",
  phone: "", // 1. Add the 'phone' property here
  subject: "",
  message: ""
});

const errors = ref({});
const loading = ref(false); // Loading state
const isSending = ref(false); // To show a sending indicator on the button
const router = useRouter();

// 1. Add this function to filter input
const formatPhoneNumber = (event) => {
  // Replace any character that is not a digit with an empty string
  const formatted = event.target.value.replace(/[^0-9]/g, '');
  formData.value.phone = formatted;
};

// Method to send a message
const sendMessage = async () => {
  // 2. Clear previous errors and perform validation
  errors.value = {};

  if (!formData.value.name) {
    errors.value.name = "Your name is required.";
  }
  if (!formData.value.email) {
    errors.value.email = "Email is required.";
  } else if (!/^\S+@\S+\.\S+$/.test(formData.value.email)) {
    errors.value.email = "Please enter a valid email address.";
  }
  // 2. Update phone validation
  if (!formData.value.phone) {
    errors.value.phone = "Phone number is required.";
  } else if (formData.value.phone.length < 10) {
    errors.value.phone = "Please enter a valid phone number (at least 10 digits).";
  }
  if (!formData.value.subject) {
    errors.value.subject = "A subject is required.";
  }
  if (!formData.value.message) {
    errors.value.message = "A message is required.";
  }

  // 3. If there are any errors, stop the function
  if (Object.keys(errors.value).length > 0) {
    return;
  }

  try {
    loading.value = true;
     isSending.value = true; // Set loading to true

    const requestBody = {
      email: formData.value.email,
      phone: formData.value.phone,
      description: formData.value.message,
      name: formData.value.name,
      subject: "General Inquiry",
      address: "General Inquiry"
    };
    console.log("Sending message with data:", requestBody);

    const response = await fetch(process.env.VUE_APP_sendEmailURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    const result = await response.json();
    console.log("Message sent successfully:", result);
    // 5. Replace the old alert with the modern SweetAlert2 modal
    Swal.fire({
      title: 'Thank You!',
      text: 'Your message has been sent successfully.',
      icon: 'success',
      confirmButtonText: 'OK',
      confirmButtonColor: '#0d6efd', // Match your site's primary color
    }).then((result) => {
      // 6. Navigate to the home page after the user clicks "OK"
      if (result.isConfirmed) {
        router.push('/');
      }
    });
    formData.value = { name: "", email: "", subject: "", message: "" };

    // Navigate to the home page with a success message
    // router.push({
    //   path: "/",
    //   query: { successMessage: "Property submitted successfully!" },
    // });
  } catch (error) {
    console.error("Error sending message:", error);
    Swal.fire({
      title: 'Error!',
      text: 'Failed to send message. Please try again later.',
      icon: 'error',
      confirmButtonText: 'OK'
    });
  } finally {
    loading.value = false; // Reset loading state
     isSending.value = false;
  }
};
</script>

<style scoped>
.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Dimmed background */
  z-index: 1050; /* Ensure it appears above other elements */
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner-container {
  text-align: center;
}
</style>
